/**
 * Formats a backend role string for UI display. Strips the `mdm-` prefix,
 * converts separators to spaces, and titlecases each word.
 *
 * Examples:
 *   `mdm-super-admin` → `Super Admin`
 *   `super_admin`     → `Super Admin`
 *   `viewer`          → `Viewer`
 *   undefined         → `User`
 */
export function formatRole(role: string | undefined | null): string {
  if (!role) return 'User';
  return role
    .replace(/^mdm-/, '')
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}
